<template lang="pug">
  y-dialog(v-model="showModal" width="300px" persistent)
    v-date-picker(v-model="dates" range no-title)
      v-spacer
      v-btn(color="white" text @click="cancel")
        .button-Aa-small.primary400--text {{ $t('cancel') }}
      v-btn.mr-2(color="primary" depressed height=32 @click="selectDate" :disabled="dates.length < 2")
        .button-AA-small.basic100--text {{ $t('select') }}
</template>

<script>
export default {
  name: "DatePickerOrder",
  props: ['open'],
  data: (vm) => ({
    dialogOpen: vm.dialog,
    dates: []
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    selectDate () {
      this.showModal = false
      this.$emit('selected', this.dates)
    },
    cancel () {
      this.showModal = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
::v-deep .v-date-picker-title__year{
  display: none;
}
::v-deep .v-date-picker-title__date {
  display: none;
}
::v-deep .v-picker__title {
  padding: 0;
}
::v-deep .v-picker__body{
  width: 100% !important;
}
::v-deep .v-date-picker-header{
  height: 61px;
}

::v-deep .v-date-picker-header > button{
  position: absolute !important;
  width: 24px;
  border-radius: 5px;
  color: black !important; /*change month and arrow color*/
}

::v-deep .v-date-picker-header > button[aria-label="Previous month"],
::v-deep .v-date-picker-header > button[aria-label="Previous year"]{
  right: 53px;
}

::v-deep .v-date-picker-header > button[aria-label="Next month"],
::v-deep .v-date-picker-header > button[aria-label="Next year"]{
  right: 24px;
}

::v-deep .v-date-picker-header > div{
  position: absolute !important;
}

::v-deep .v-date-picker-header .v-date-picker-header__value button::after{
  font-family: "Material Design Icons";
  content: "\F0140";
  margin-left: 12px;
}
::v-deep .v-date-picker-table th {
  font-size: 15px;
  color: rgba(143, 155, 179, 1) !important; /*change days name color text*/
  height: 44px;
  border-bottom: 1px solid rgb(244,244,244);
  border-top: 1px solid rgb(244,244,244);
}

::v-deep .v-date-picker-table--date {
  height: 290px;
  padding: 0 8px 0 8px;
}

::v-deep .v-date-picker-table .v-btn {
  height: 44px;
  width: 44px;
  font-size: 15px !important;
  font-weight: 600;
  border-radius: 4px !important;
}
::v-deep .v-date-picker-table__current{
  border: 2px solid black; /*change current date color border*/
  color: black !important;
  background-color: rgba(51, 51, 51, 0.08); /*change current date color bg*/
}
::v-deep .v-date-picker-table .v-btn.v-btn--disabled {
  color:rgba(143, 155, 179, 1) !important; /*change disabled date color text*/
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background-color: rgba(102, 144, 255, 1); /*change active/selected date color bg*/
}

::v-deep .v-date-picker-table--date .v-date-picker-table__events{
  bottom: 12px;
}

::v-deep .v-date-picker-table__events > div{
  width: 5px;
  height: 5px;
}

::v-deep .v-date-picker-table--month td .v-btn {
  margin: 0 auto;
  max-width: 140px;
  min-width: 40px;
  width: 100%;
  font-size: 15px !important;
  font-weight: 600 !important;
}
::v-deep .v-date-picker-years {
  font-size: 15px;
  font-weight: 600;
  height: 290px;
  list-style-type: none;
  overflow: auto;
  text-align: center;
}
</style>